import ImportStatusBadge from "./ImportStatusBadge";
import ValidationMessageList from "./ValidationMessageList";

export default function CustomerImportPreviewTable({ rows }) {
  if (!Array.isArray(rows) || rows.length === 0) return null;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900">4. Preview</h3>
      <p className="mt-1 text-sm text-slate-500">Controleer acties per rij voordat je importeert.</p>

      <div className="mt-3 overflow-x-auto">
        <table className="min-w-full text-left text-xs">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500">
              <th className="px-2 py-2">Rij</th>
              <th className="px-2 py-2">Bedrijfsnaam</th>
              <th className="px-2 py-2">Status</th>
              <th className="px-2 py-2">Actie</th>
              <th className="px-2 py-2">Validatie</th>
            </tr>
          </thead>
          <tbody>
            {rows.slice(0, 120).map((row) => (
              <tr key={`preview-${row.rowNumber}`} className="border-b border-slate-100 align-top last:border-b-0">
                <td className="px-2 py-2 text-slate-700">{row.rowNumber}</td>
                <td className="px-2 py-2 text-slate-900">{row.normalized?.bedrijfsnaam || "-"}</td>
                <td className="px-2 py-2 text-slate-700">{row.normalized?.status || "-"}</td>
                <td className="px-2 py-2">
                  <ImportStatusBadge status={row.action} />
                  {row.duplicateClientName && (
                    <p className="mt-1 text-[11px] text-slate-500">Match: {row.duplicateClientName}</p>
                  )}
                </td>
                <td className="px-2 py-2 space-y-1">
                  <ValidationMessageList title="Fouten" items={row.errors} tone="error" />
                  <ValidationMessageList title="Waarschuwingen" items={row.warnings} tone="warning" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
